import * as React from "react";

/**
 * Figma Node IDs:
 * Design Frame: 377:42194
 * Instance IDs: I377:42154;74:2277, I377:42177;74:2277, I1269:15498;74:2277, I1269:15516;74:2277, I1258:11173;1:8022, I1258:11173;48:4235
 * Composite: true
 * Last Updated: 2024-12-23
 * Generated by: Claude Code figma-component command
 */

import { Lightbulb, BadgeCheck } from "@labxchange/icons";

import { BodyText } from "../BodyText";
import { Heading } from "../Heading";
import { LxButton } from "../LxButton";
import * as styles from "./SpecialTextBox.css";

interface SpecialTextBoxProps {
  children?: React.ReactNode;
  title?: string;
  listItems?: string[];
  listType?: "icon" | "numeric";
  listItemIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  buttonText?: string;
  onButtonClick?: () => void;
  showTitleIcon?: boolean;
  titleIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  enableMath?: boolean;
  testId?: string;
}

export const SpecialTextBox = ({
  children,
  title,
  listItems,
  listType = "icon",
  listItemIcon: ListItemIcon = BadgeCheck,
  buttonText,
  onButtonClick,
  showTitleIcon = false,
  titleIcon: TitleIcon = Lightbulb,
  enableMath = false,
  testId,
}: SpecialTextBoxProps) => {
  return (
    <div className={styles.specialTextBoxContainer} data-testid={testId}>
      <div className={styles.specialTextBoxContent}>
        {title && (
          <div className={styles.titleSection}>
            {showTitleIcon && <TitleIcon className={styles.titleIcon} />}
            <Heading size="xl" className={styles.titleText}>
              {title}
            </Heading>
          </div>
        )}

        {children && (
          <BodyText className={styles.paragraphText} equation={enableMath}>
            {children}
          </BodyText>
        )}

        {listItems && listItems.length > 0 && (
          <ul className={styles.listContainer}>
            {listItems.map((item, index) => (
              <li key={index} className={styles.listItem}>
                <div className={styles.listIconContainer}>
                  {listType === "numeric" ? (
                    <span className={styles.listNumber}>{index + 1}.</span>
                  ) : (
                    <ListItemIcon className={styles.listIcon} />
                  )}
                </div>
                <BodyText className={styles.listItemText} equation={enableMath}>
                  {item}
                </BodyText>
              </li>
            ))}
          </ul>
        )}

        {buttonText && (
          <div>
            <LxButton
              text={buttonText}
              onClickHandler={onButtonClick}
              trailingIcon="next"
            />
          </div>
        )}
      </div>
    </div>
  );
};
